import type {
  AssessmentResultFileRecord,
  AssessmentSessionRecord,
} from "@graftus/schema";

/** Default provider for assessment uploads in the UI today. */
export const DEFAULT_ASSESSMENT_PROVIDER_ID = "capacio" as const;

export type CapacioInstrumentKey = "cognitive" | "personality";

export interface CapacioInstrumentDef {
  instrumentKey: CapacioInstrumentKey;
  title: string;
  shortLabel: string;
}

/** Capacio: two distinct tests / two PDFs; usually uploaded together in one session. */
export const CAPACIO_INSTRUMENTS: readonly CapacioInstrumentDef[] = [
  {
    instrumentKey: "cognitive",
    title: "Kognitivt resultat",
    shortLabel: "Kognitivt",
  },
  {
    instrumentKey: "personality",
    title: "Personlighetsresultat",
    shortLabel: "Personlighet",
  },
] as const;

export function instrumentTitleForProvider(
  providerId: string | null | undefined,
  instrumentKey: string,
): string {
  if (providerId === DEFAULT_ASSESSMENT_PROVIDER_ID) {
    const row = CAPACIO_INSTRUMENTS.find(
      (i) => i.instrumentKey === instrumentKey,
    );
    if (row) return row.title;
  }
  return instrumentKey;
}

export function resultFileForInstrument(
  session: AssessmentSessionRecord,
  instrumentKey: string,
): AssessmentResultFileRecord | null {
  for (const f of Object.values(session.resultFiles)) {
    if (f.instrumentKey === instrumentKey) return f;
  }
  return null;
}
